import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./sections/Navbar/Navbar";
import Footer from "./sections/Footer/Footer";

export default function Layout() {
  const layoutStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  };

  const mainStyle = {
    flexGrow: 1,
  };

  return (
    <div style={layoutStyle}>
      <Navbar />
      <main style={mainStyle}>
        <Suspense fallback={<div>Loading...</div>}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
